import { StandardStatus } from '@zoocasa/go-search';
import styles from './status-badge.module.scss';

export interface StatusBadgeProps {
  label: string;
  status: StandardStatus;
  className?: string;
}

export function StatusBadge({ label, status, className }: StatusBadgeProps) {
  const statusClass = getStatusClass(status);

  return (
    <div className={`${styles.component} ${statusClass} ${className || ''}`}>
      <p>{label}</p>
    </div>
  );
}

function getStatusClass(status: StandardStatus): string {
  switch (status) {
    case StandardStatus.STANDARD_STATUS_ACTIVE:
    case StandardStatus.STANDARD_STATUS_ACTIVE_UNDER_CONTRACT:
      return styles['active'];
    case StandardStatus.STANDARD_STATUS_CLOSED:
      return styles['closed'];
    case StandardStatus.STANDARD_STATUS_EXPIRED:
      return styles['expired'];
    case StandardStatus.STANDARD_STATUS_CANCELED:
      return styles['canceled'];
    case StandardStatus.STANDARD_STATUS_HOLD:
    case StandardStatus.STANDARD_STATUS_WITHDRAWN:
    case StandardStatus.STANDARD_STATUS_PENDING:
      return styles['inactive'];
    default:
      return styles['other'];
  }
}
